import { CardRecAlternateNames } from '@/components/common/Card'
import { usePage } from '@/components/providers/PageProvider'

export const FeaturedRecInfoAlternateNames = () => {
  const { page } = usePage()
  const rec = page?.featured?.rec

  if (!rec) return null

  return <CardRecAlternateNames rec={rec} />
}
